import { render } from "./Key2.vue?vue&type=template&id=53c77009"
import script from "./Key2.vue?vue&type=script&lang=ts"
export * from "./Key2.vue?vue&type=script&lang=ts"
script.render = render

export default script